/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  entertainmentCreditRequest,
  entertainmentCreditSuccess,
  entertainmentCreditFailed,
} from '../reducer/entertainmentCreditSlice';
import { submitEntertainmentCreditForm } from '../api';
 // make sure this matches your api file export

type SubmitAction = {
  type: string;
  payload: {
    apiName: string;
    data: any; // request body
    accountId: string;
  };
};

export function* entertainmentCreditSaga(action: SubmitAction): Generator<any, void, unknown> {
  
  try {
   const {accountId,data} = action.payload || {};
  console.log('entertainmentCreditSaga before', data);

    const response: any = yield call(submitEntertainmentCreditForm,'entertainmentCredit_Submit',accountId,data);
    console.log('entertainmentCreditSaga response', response);
    if (response.statuscode === '200') {
      // Include the original request for debugging/audit if useful
      yield put(
        entertainmentCreditSuccess(response)
      );
    } else {
      yield put(entertainmentCreditFailed(response));
    }
  } catch (error: any) {
    // Try to read from error.data shape (like your signInSaga)
    console.log("error entertainment",error);
    const apiErr = error?.data ?? error?.response?.data ?? error;
    yield put(entertainmentCreditFailed(apiErr));
  }
}

export function* watchEntertainmentCreditSubmit() {
  yield takeLatest(entertainmentCreditRequest.type, entertainmentCreditSaga);
}
